"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgFont(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M21.2 21.979a1.01 1.01 0 01.118 2.014L21.2 24H3.01a1.01 1.01 0 01-.117-2.014l.118-.007H21.2zM12.741.345l.057.105 8.084 18.19a.758.758 0 01-1.337.706l-.048-.09-2.047-4.604H6.759l-2.045 4.603a.758.758 0 01-.904.42l-.097-.035a.758.758 0 01-.42-.904l.035-.096L11.413.45A.758.758 0 0112.74.345zm-.636 2.278L7.433 13.136h9.344L12.105 2.623z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgFont;
exports.default = _default;